import Button from 'components/Form/Button';
import { CoreContext } from 'context/CoreContext';
import { useContext, useRef, useState } from 'react';
import { toast } from 'react-toastify';
import { UpdateForceCuradoria } from 'services/financing-proposals';
import { Create } from 'services/historico';
import { theme } from 'ui/theme-color';
import FormCore from '../../Form/Core';
import Wrapper from '../Wrapper';
import { ProposalCurationBanner } from './components/ProposalCurationBanner';
import { ActionButtonContainer, Label, ReadOnlyField } from './styled';

export default function MotivoRecusa({ dados }) {
  const { user, setModal } = useContext(CoreContext);
  const refFormObservation = useRef(null);
  const [isLoading, setIsLoading] = useState(false);
  const idProposta = dados?.id;
  const status = !dados?.status_obs ? 'Sem observação' : dados?.status_obs;
  const curationStatus = dados?.curadoria_analise;
  const canChangeCuration = user?.force_curadoria && curationStatus === 'Não';

  const formObservation = [
    {
      ref: 'obs',
      placeholder: 'Observação',
      type: 'text',
      required: true,
      full: true,
      multiline: true,
      maxRows: 4,
      height: 100,
    },
  ];

  function formatarMotivosRecusa(motivos) {
    if (!motivos || motivos.length === 0) {
      return 'Nenhum motivo de recusa encontrado.';
    }
    let resultadoFormatado = '';
    motivos.forEach((item) => {
      resultadoFormatado += `Banco: ${item.banco}\n`;
      item.regras.forEach((regra) => {
        resultadoFormatado += `  - Regra: ${regra.regra}\n`;
        resultadoFormatado += `    Detalhes: ${regra.detalhes}\n`;
      });
      resultadoFormatado += `\n`;
    });

    return resultadoFormatado;
  }

  const handleSubmitCuradoria = async (idProposta) => {
    const userId = user.id;
    const obsValue = refFormObservation.current?.getItem('obs');

    const obsPayload = {
      data: {
        users_permissions_user: user.id,
        data: new Date(),
        observacao: obsValue,
        origem: 'Inelegível',
        proposta_financeira: idProposta,
      },
    };

    try {
      setIsLoading(true);
      await UpdateForceCuradoria(idProposta, {
        userId,
      });

      await Create(obsPayload);

      toast.success('Proposta enviada para Curadoria com sucesso!');
    } catch (err) {
      toast.error(
        !!err?.message
          ? err.message
          : 'Ocorreu um erro ao enviar proposta para curadoria.'
      );
    } finally {
      setIsLoading(false);
    }
  };

  let motivoBanco = formatarMotivosRecusa(dados?.motivos_recusa);

  let motivoFatura = formatarMotivosRecusa(dados?.motivos_recusa_fatura);

  function formatarMotivosRecusaBanking(motivos) {
    if (!motivos || motivos.length === 0) {
      return 'Nenhum motivo de recusa encontrado.';
    }
    let resultadoFormatado = '';
    motivos.forEach((item) => {
      resultadoFormatado += `  - Regra: ${item.regra}\n`;
      resultadoFormatado += `    Detalhes: ${item.detalhe}\n`;
    });
    resultadoFormatado += `\n`;

    return resultadoFormatado;
  }

  let motivosBanking = formatarMotivosRecusaBanking(dados?.motivos_reprovado);

  if (motivoFatura == 'null') {
    motivoFatura = 'Sem motivo';
  }
  if (motivoBanco == '[]') {
    motivoBanco = 'Sem motivo';
  }
  if (motivosBanking == 'null') {
    motivosBanking = 'Sem motivo';
  }

  const close = () => setModal(null);

  return (
    <Wrapper
      title={
        <div
          style={{
            display: 'flex',
            flexDirection: 'column',
          }}
        >
          <span>Motivos Recusa</span>
          <p
            style={{
              margin: '0',
              color: theme.palette.colors.grey,
              fontSize: '18px',
              fontWeight: 500,
            }}
          >
            Proposta: <strong>{idProposta}</strong>
          </p>
        </div>
      }
    >
      {(curationStatus === 'Sim' || curationStatus === 'Recusado') && (
        <ProposalCurationBanner status={curationStatus} />
      )}

      <div>
        <Label>Status</Label>
        <ReadOnlyField>
          <strong>{status}</strong>
        </ReadOnlyField>
      </div>
      <div>
        <Label>Motivos Banco</Label>
        <ReadOnlyField>
          <strong>{motivoBanco}</strong>
        </ReadOnlyField>
      </div>
      <div>
        <Label>Motivos Fatura</Label>
        <ReadOnlyField>
          <strong>{motivoFatura}</strong>
        </ReadOnlyField>
      </div>
      <div>
        <Label>Motivo Banking</Label>
        <ReadOnlyField>
          <strong>{motivosBanking}</strong>
        </ReadOnlyField>
      </div>
      <div></div>

      {canChangeCuration && (
        <FormCore ref={refFormObservation} formItems={formObservation} />
      )}

      <ActionButtonContainer>
        <div>
          <Button
            disabled={!canChangeCuration}
            color="blue"
            onClick={() => handleSubmitCuradoria(idProposta)}
            loading={isLoading}
          >
            Enviar para curadoria
          </Button>
        </div>
        <Button
          onClick={close}
          color="lightgrey"
          border
          nospace
          loading={isLoading}
        >
          Fechar
        </Button>
      </ActionButtonContainer>
    </Wrapper>
  );
}
